import { AutoComplete, Button, Card, DatePicker, Form, Icon, Input, Select, Spin } from 'antd';
import React from 'react';
import moment from 'moment';
import { getFormFieldByType, sanitizeFieldName } from '../../util/methods';
import SubList from '../../components/SubList';
import CreateActivityModal from '../../components/CreateActivityModal';
import FieldSearchForm from "../../components/FieldSearchForm";
import PageSettingPopUp from "../PageSetting/settingForm";

// let activityData = [];

class Create extends React.Component {
  constructor() {
    super();
    this.addSpareRequired = this.addSpareRequired.bind(this);
    this.id = 0;
    this.state = {
      activityData: [],
      keys: [],
      addComplaint: false,
      complaintId: null,
      source: '',
    };
  }


  componentDidMount() {
    const { match, fetch, history: { location }, form } = this.props;
    if (match.params && match.params.id) {
      fetch && fetch(match.params.id);
    }
    if (location && location.state && location.state.locationId) {
      this.props.getComplaintData(location.state.locationId);
    }

    const data = [];
    this.setState({
      keys: data,
      addComplaint: !!(location && location.state && location.state.complaintId),
      complaintId: location && location.state && location.state.complaintId,
      source: location && location.state && location.state.source,
    });
    this.props.getLocationByQuery();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data.spareRequired,
      });
    }
  }

  componentDidUpdate(prevState) {
    if (this.props.form.getFieldsValue() && Object.keys(this.props.form.getFieldsValue()).length && Object.keys(this.props.form.getFieldsValue()).includes('complaint') && this.state.addComplaint) {
      this.props.form.setFieldsValue({ 'complaint': this.props.history.location.state.complaintId });
      this.setState({ addComplaint: false });
    }
  }

  componentWillUnmount() {
    this.props.clearProps();
  }

  getActivityData = (data) => {
    this.setState({ activityData: data }, () => {
      this.props.form.setFields({
        activities: {
          errors: []
        }
      })
    });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      const data = Object.assign({}, values);
      delete data.jobCardNo;
      delete data.status;
      const { activityData } = this.state;
      if (activityData && activityData.length === 0) {
        data.activities = this.props && this.props.data && this.props.data.activities;
      } else {
        data.activities = activityData;
      }
      if (!data.activities || !data.activities.length) {
        this.props.form.setFields({
          activities: {
            errors: [new Error('Please Add minimum one activity')]
          }
        });
        return;
      } else {
        if (match.params && match.params.id) {
          delete data.complaint;
          this.props.onSubmit(data, match.params.id);
        } else {
          this.props.onSubmit(data, this.state.source);
          this.props.form.resetFields();
        }
      }
    });
  };

  formItems() {
    const { data, form, filters, resource, title } = this.props;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys.map((k, index) => {

      return <div key={index} style={style}>

        <FieldSearchForm
          title={title}
          otherDetails={{ title, resource, setFieldsValue }}
          options={filters['spareRequired'] && filters['spareRequired']['schema'] && filters['spareRequired']['schema']['spareName'].options}
          key={'spareName'}
          name={`spareRequired[${index}]['spareName']`}
          label={'Spare Name'}
          message={`Spare Name is required`}
          required={true}
          disabled={(title === 'EDIT' && filters['spareRequired'] && filters['spareRequired']['schema'] && filters['spareRequired']['schema']['spareName'].options.disabledOnEdit) || false}
          field={filters['spareRequired'] && filters['spareRequired']['schema'] && filters['spareRequired']['schema']['spareName'].options.main}
          model={filters['spareRequired'] && filters['spareRequired']['schema'] && filters['spareRequired']['schema']['spareName'].options.ref}
          initialValue={k && k.spareName}
          getFieldDecorator={getFieldDecorator}
          setFieldsValue={setFieldsValue}
        />

        <Form.Item key={`${index}3`} label={'Quantity'}>
          {getFieldDecorator(`spareRequired[${index}]['quantity']`, {
            rules: [{ required: false, message: `quantity is required!` }],
            initialValue: k && k.quantity,
          })(<Input placeholder={'Quantity'} style={{ marginRight: 8 }} />)
          }
        </Form.Item>

        {index > 0 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.removeSpareRequired(`${k}`)}
          />
        ) : null}
      </div>
    });
  }

  changeComplaintValue = () => {
    this.props.form.setFieldsValue({ 'complaint': '' });
  }

  handleComplaintChange = (complaintId) => {
    const { complaint, form, title } = this.props
    if (title === 'CREATE' && complaint && complaintId) {
      const selectedComplaint = complaint.find(item => item._id === complaintId)
      if (selectedComplaint && selectedComplaint.complaintDate) {
        form.setFieldsValue({
          jobCardDate: moment(selectedComplaint.complaintDate)
        })
      }
    }
  }

  addSpareRequired = () => {
    const { keys } = this.state;
    keys.push(`${'spareRequired'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  removeSpareRequired = index => {
    const { keys } = this.state;
    if (keys.length === 1) {
      return;
    }

    keys.splice(index, 1);
    this.setState({
      keys: keys,
    });
  };

  getInitialDateValue = (title, data) => {
    console.log(this.props.history.location.state, 'history.location');
    if (title === 'EDIT') {
      return data && data.jobCardDate ? moment(data.jobCardDate) : moment()
    } else {
      // CREATE mode: check if there's a complaint with complaintDate
      const complaintDate = this.props.history.location.state.complaintDate
      console.log(complaintDate, 'complaintDate');
      if (complaintDate) {
        return moment(complaintDate)
      }
      return moment()
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, allLocation, complaint, authUser, match, history } = this.props;
    // console.log(this.props.history);
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>

          {/*<PageSettingPopUp toggleVisible={this.props.togglePageSettingVisible} visible={this.props.pageSettingVisible}*/}
          {/*                  page={resource} loading={loading}*/}
          {/*                  fetchResourceByPage={this.props.fetchResourceByPage} pageSettingData={this.props.pageSettingData}*/}
          {/*                  fetchPageWiseFields={this.props.fetchPageWiseFields}  pageWiseFields={this.props.pageWiseFields}*/}
          {/*                  fetchPageSettingFilter={this.props.fetchPageSettingFilter} pageSettingFilters={this.props.pageSettingFilters}*/}
          {/*                  updatePageSetting={this.props.updatePageSetting}/>*/}

          <Form onSubmit={this.handleSubmit} layout="vertical">
            {
              (title === 'EDIT') && <Form.Item key={'jobCardNo'} label={'Job Card Number'}>
                {getFieldDecorator('jobCardNo', {
                  rules: [{ required: false, message: `Job Card Number is required!` }],
                  initialValue: ((data && data.jobCardNo) || ''),
                })(<Input disabled />)
                }
              </Form.Item>
            }

            {
              title !== 'CREATE' && <Form.Item key={'status'} label={'Status'}>
                {getFieldDecorator('status', {
                  rules: [{ required: false, message: `Status is required!` }],
                  initialValue: data && data.status,
                })(<Select
                  style={{ width: '100%' }}
                  placeholder="Please select"
                  disabled
                >
                  {filters['status'] && filters['status'].options.enum.map(item => <Select.Option key={item}
                    value={item}>{item}</Select.Option>)}
                </Select>)
                }
              </Form.Item>
            }

            {
              title === 'CREATE' && <Form.Item key={'location'} label={'Search Location'}>
                <AutoComplete
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  onSelect={this.props.getComplaintData}
                  onChange={this.changeComplaintValue}
                  placeholder={'ex. abc'}>
                  {
                    allLocation && allLocation.map((item) => {
                      return <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>
                    })
                  }
                </AutoComplete>
              </Form.Item>
            }

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema && item !== 'spareRequired' && item !== 'statusUpdate' && item !== 'changeStatus') {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title}
                  resource={resource} />;
              } else {
                if (item !== 'jobCardDate' && item !== 'activities' && item !== 'complaint' && item !== 'status' && item !== 'followUp' && item !== 'followUpDate' && item !== 'closureDate') {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource });
                }
              }
              if (filters[item].field === 'complaint') {
                return <Form.Item key={'complaint'} label={'Complaint'}>
                  {getFieldDecorator('complaint', {
                    rules: [{ required: true, message: `Complaint is required!` }],
                    initialValue: title === 'CREATE' ? this.props.history.location.state.complaintId || null : data && data.complaint && (data.complaint._id || data.complaint),
                  })(<Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={title === 'EDIT'}
                    onChange={this.handleComplaintChange}
                  >
                    {complaint && complaint.map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.complaintNo}</Select.Option>)}
                  </Select>)}
                </Form.Item>
              }
              if (filters[item].field === 'jobCardDate') {
                // In EDIT mode, always use data.jobCardDate
                // In CREATE mode, use complaintDate if available, otherwise current date

                return <Form.Item key={'jobCardDate'} label={'Job Card Date'}>
                  {getFieldDecorator('jobCardDate', {
                    rules: [{ required: true, message: `Job Card Date is required!` }],
                    initialValue: this.getInitialDateValue(title, data),
                  })(<DatePicker disabled={title === 'EDIT'} style={{ width: '100%' }} />)}
                </Form.Item>
              }

              if (filters[item].type === 'Array' && filters[item].options.ref) {
                return <Form.Item key={'activities'} label={'Activities'}>
                  {getFieldDecorator('activities', {
                    rules: [{ required: false, message: `Activities are required!` }]
                  })(<CreateActivityModal
                    match={match}
                    history={history}
                    authUser={authUser}
                    resourceName={resource}
                    key={item}
                    title={title}
                    jcData={data}
                    item={filters[item]}
                    form={form}
                    data={data[item]}
                    getActivityData={this.getActivityData} />)
                  }
                </Form.Item>
              }
            })}
            <div>Spare Required</div>
            {this.formItems()}
            <Button type="dashed" onClick={this.addSpareRequired} style={{ width: '60%', marginTop: '15px' }}>
              <Icon type="plus" /> Add Spare Required
            </Button>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
